import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { removeEmptyFields, ServiceOffer, ServiceTypes, SkillPath, TutoringType, UserTypeId } from "../../common/const";
import { Add, Close } from "@mui/icons-material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import CommonSelect from "../../common/components/CommonSelect";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import CommonDialog from "../../common/components/CommonDialog";
import CommonFormField from "../../common/components/CommonFormField";
import { setLoading } from "../../features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { assignSubject, getAllAssignSubject, getAllSubject } from "../../api/subjectApi";
import { createStudentScore } from "../../api/scoreApi";

const Type = {
    Assignment: 'Assignment',
    Quiz: 'Quiz',
    Test: 'Test'
};

const SubjectOverview = ({
    tutoringType,
    getStats,
    currentService,
    fromMentor,
    label,
    currentGrade,
    pathname,
    getAllAssignSubjects,
    studentId
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [subjectList, setSubjectList] = useState([]);
    const [apSubject, setApSubject] = useState([]);
    const [addScore, setAddScore] = useState(false);
    const [addSubject, setAddSubject] = useState(false);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [type, setType] = useState(Type.Assignment);
    const [errors, setErrors] = useState({});
    const pageNo = 1;
    const pageSize = 100;
    const [formData, setFormData] = useState({
        scoredate: '',
        score: '',
        subject: '',
        semester: 'SEMESTER_1'
    });

    const validateField = (name, value) => {
        switch (name) {
            case 'scoredate':
                if (!value) return 'Date is required';
                return '';
            case 'score':
                if (!value) return 'Score is required';
                return '';
            case 'subject':
                if (!value) return 'Subject is required';
                return '';
            case 'semester':
                if (!value && pathname !== SkillPath) return 'Semester is required';
                return '';
            default:
                return '';
        }
    };

    const validateForm = () => {
        const newErrors = {};
        Object.keys(formData).forEach(key => {
            const error = validateField(key, formData[key]);
            if (error) newErrors[key] = error;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (errors[name]) {
            const error = validateField(name, value);
            if (!error) {
                setErrors(prev => ({ ...prev, [name]: undefined }));
            } else {
                setErrors(prev => ({ ...prev, [name]: error }));
            }
        }
    };

    const handleSubmit = async () => {
        try {
            if (!validateForm()) return;
            const response = await createStudentScore(removeEmptyFields({
                "student_subject_id": tutoringType === TutoringType.AP ? formData.subject : '',
                "subject_id": tutoringType === TutoringType.ACADEMIC ? formData.subject : apSubject.find((a) => a.student_subject_id === formData?.subject)?.subject?.subject_id,
                "services_type": pathname === SkillPath ? ServiceOffer.skillCoach : ServiceTypes[tutoringType],
                "type": type.toUpperCase(), //ASSIGNMENT QUIZ TEST
                "semester": formData.semester, // SEMESTER_1 SEMESTER_2
                "score": formData.score,
                "exam_date": new Date(formData.scoredate)?.toISOString(),
                "title": ServiceTypes[tutoringType]
            }));
            if (response?.success) {
                showNotification(response.message, 'success');
                setFormData({
                    scoredate: '',
                    score: '',
                    semester: 'SEMESTER_1',
                    subject: ''
                });
                setType(Type.Assignment);
                setAddScore(false);
                getStats();
            }
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    const getSubjects = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAllSubject(pageNo, pageSize, (pathname === SkillPath ? 'SKILL' : ServiceTypes[tutoringType]) || currentService, (tutoringType === TutoringType.ACADEMIC || ServiceOffer.academic === currentService) ? user?.student_current_grade || currentGrade || '' : '');
            setSubjectList(response?.data?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    const getAssignedSubject = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAllAssignSubject((currentService === ServiceOffer.skillCoach ? ServiceOffer.skillCoach : pathname === '/dcp-skill-coaching' ? ServiceOffer.skillCoach : ServiceTypes[tutoringType]) || currentService, user?.student_id || studentId);
            setApSubject(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    useEffect(() => {
        getSubjects();
        if ((tutoringType === TutoringType.AP || currentService === ServiceOffer.tutor) || currentService === ServiceOffer.skillCoach) {
            getAssignedSubject();
        }
    }, [tutoringType, currentService, pathname, studentId]);

    return (
        <Fragment>
            <CommonDialog
                open={addSubject}
                size="xs"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 600, fontSize: 18 }}>{pathname === SkillPath ? 'Add Coding/Skill/Technology' : 'Add Subject'}</Typography>
                            <Close
                                sx={{
                                    color: theme.palette.background.dark, fontSize: 20,
                                    float: 'right',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setAddSubject(false);
                                    setSelectedSubject(null);
                                }}
                            />
                        </Box>
                        <Box width="80%" mb={1}>
                            <Typography sx={{ fontSize: 12 }} color={theme.palette.background.dark}>{pathname === SkillPath ? 'Enter a coding/skill/technology to organize your content.' : 'Enter a subject to organize your content.'}</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Box mt={1} mb={1}>
                        <CommonSelect
                            label={pathname === SkillPath ? 'Coding/Skill/Technology' : "Subject"}
                            name="subjects"
                            value={selectedSubject}
                            onChange={(e) => setSelectedSubject(e.target.value)}
                            placeholder={pathname === SkillPath ? 'Select Coding/Skill/Technology' : "Select Subject"}
                            options={subjectList.map((a) => ({
                                label: a.name,
                                value: a.subject_id
                            }))}
                        />
                    </Box>
                }
                actionButtons={(
                    <CommonButton
                        label={pathname === SkillPath ? 'Add Coding/Skill/Technology' : 'Add Subject'}
                        size="small"
                        startIcon={<Add style={{ fontSize: '15px' }} />}
                        background={theme.palette.secondary.main}
                        color={theme.palette.background.main}
                        fontWeight={700}
                        marginBottom="10px"
                        handleClick={async () => {
                            if (selectedSubject !== null) {
                                try {
                                    dispatch(setLoading({
                                        loading: true
                                    }));
                                    const response = await assignSubject({
                                        "subject_id": selectedSubject,
                                        "type": pathname === SkillPath ? ServiceOffer.skillCoach : ServiceTypes[tutoringType]
                                    });
                                    if (response.success) {
                                        showNotification(response.message, 'success');
                                        setSelectedSubject(null);
                                        setAddSubject(false)
                                        getAssignedSubject();
                                        if (getAllAssignSubjects) {
                                            getAllAssignSubjects();
                                        }
                                        dispatch(setLoading({
                                            loading: false
                                        }));
                                    }
                                } catch (err) {
                                    const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                    showNotification(errorMessage, 'error');
                                    dispatch(setLoading({
                                        loading: false
                                    }));
                                }
                            } else {
                                showNotification('Please select subject', 'error');
                            }
                        }}
                    />
                )}
            />
            <CommonDialog
                open={addScore}
                size="xs"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 600, fontSize: 18 }}>Add New Score</Typography>
                            <Close
                                sx={{
                                    color: theme.palette.background.dark, fontSize: 20,
                                    float: 'right',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setAddScore(false);
                                    setFormData({
                                        scoredate: '',
                                        score: '',
                                        semester: 'SEMESTER_1',
                                        subject: ''
                                    });
                                    setType(Type.Assignment);
                                }}
                            />
                        </Box>
                        <Box width="80%" mb={1}>
                            <Typography sx={{ fontSize: 12 }} color={theme.palette.background.dark}>Enter a new score and save it to your record.</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container spacing={2} mt={0.1} mb={2}>
                        <Grid item sm={12}>
                            <Typography fontWeight={600} fontSize={14}>Select Type</Typography>
                            <Box display="flex" gap={1} mt={0.5}>
                                <CommonButton
                                    label={Type.Assignment}
                                    width="120px"
                                    fontWeight={600}
                                    color={type === Type.Assignment ? theme.palette.primary.main : theme.palette.background.dark}
                                    background={type === Type.Assignment ? theme.palette.secondary.main : theme.palette.background.main}
                                    handleClick={() => setType(Type.Assignment)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                                <CommonButton
                                    label={Type.Quiz}
                                    width="100px"
                                    fontWeight={600}
                                    color={type === Type.Quiz ? theme.palette.primary.main : theme.palette.background.dark}
                                    background={type === Type.Quiz ? theme.palette.secondary.main : theme.palette.background.main}
                                    handleClick={() => setType(Type.Quiz)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                                <CommonButton
                                    label={Type.Test}
                                    width="100px"
                                    fontWeight={600}
                                    color={type === Type.Test ? theme.palette.primary.main : theme.palette.background.dark}
                                    background={type === Type.Test ? theme.palette.secondary.main : theme.palette.background.main}
                                    handleClick={() => setType(Type.Test)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <CommonSelect
                                label="Subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleInputChange}
                                error={errors.subject}
                                placeholder="Select Subject"
                                options={tutoringType === TutoringType.AP ? apSubject?.map((a) => ({
                                    label: a?.subject?.name,
                                    value: a.student_subject_id
                                })) : subjectList?.map((a) => ({
                                    label: a.name,
                                    value: a.subject_id
                                }))}
                            />
                        </Grid>
                        {pathname !== SkillPath && (
                            <Grid item xs={12}>
                                <CommonSelect
                                    label="Semester"
                                    name="semester"
                                    value={formData.semester}
                                    onChange={handleInputChange}
                                    error={errors.semester}
                                    placeholder="Select Semester"
                                    options={[{
                                        label: 'Semester 1', value: 'SEMESTER_1'
                                    },
                                    {
                                        label: 'Semester 2', value: 'SEMESTER_2'
                                    }]}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <CommonFormField
                                label="Select Date"
                                type="date"
                                name="scoredate"
                                value={formData.scoredate}
                                onChange={handleInputChange}
                                error={errors.scoredate}
                                placeholder="Select date"
                            />
                        </Grid>
                        <Grid item md={12} sm={12}>
                            <CommonFormField
                                label="New Score"
                                type="number"
                                name="score"
                                value={formData.score}
                                onChange={handleInputChange}
                                error={errors.score}
                                placeholder="Enter score"
                            />
                        </Grid>
                    </Grid>
                }
                actionButtons={(
                    <CommonButton
                        label="Add Score"
                        size="small"
                        background={theme.palette.secondary.main}
                        color={theme.palette.background.main}
                        fontWeight={700}
                        marginBottom="10px"
                        handleClick={() => {
                            handleSubmit();
                        }}
                    />
                )}
            />
            <CommonCard
                paddingBottom="0px"
                padding="0px"
                borderRadius={2}
                border={fromMentor && `1px solid #0000001A`}
                marginTop={fromMentor && "0px"}
                headerContent={
                    <Fragment>
                        <Box padding={2} display="flex" justifyContent="space-between">
                            <Box>
                                <Typography fontWeight={600}>{fromMentor ? label : pathname === SkillPath ? 'Skill Tracking & Progress' : 'Subject Overview'}</Typography>
                                {!fromMentor && (
                                    <Typography fontSize={13} color="background.dark">{pathname === SkillPath ? 'Manage your coding/skill/technology and track their status.' : 'Manage your subjects and track their status.'}</Typography>
                                )}
                            </Box>
                            {user?.user_type_id === UserTypeId.Student && (
                            <Box display="flex" gap={1}>
                                {tutoringType === TutoringType.AP && (
                                    <CommonButton
                                        label={pathname === SkillPath ? "Add Skill" :"Add New Subject"}
                                        startIcon={<Add />}
                                        marginBottom="0px"
                                        width={pathname === SkillPath ? "140px" : "190px"}
                                        height="35px"
                                        fontWeight={600}
                                        handleClick={() => setAddSubject(true)}
                                    />)}
                                {!fromMentor && (
                                    <CommonButton
                                        label="Add New Score"
                                        startIcon={<Add />}
                                        marginBottom="0px"
                                        width="170px"
                                        height="35px"
                                        fontWeight={600}
                                        color="White"
                                        background={theme.palette.secondary.main}
                                        handleClick={() => setAddScore(true)}
                                    />
                                )}
                            </Box>)}
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container spacing={1.5} p={2}>
                        {(((tutoringType === TutoringType.AP || ServiceOffer.tutor === currentService) || ServiceOffer.skillCoach === currentService) ? apSubject : subjectList)?.map((a, index) => (
                            <Grid item md={fromMentor ? 6 : 3} key={index}>
                                <CommonCard
                                    paddingBottom="0px"
                                    border={`1px solid #0000001A`}
                                    borderRadius={1}
                                    marginTop="0px"
                                    content={
                                        <Fragment>
                                            <Box
                                                sx={{
                                                    background: '#01875F',
                                                    textAlign: 'center',
                                                    height: 25,
                                                    width: 60,
                                                    borderRadius: 1,
                                                    paddingTop: 0.3,
                                                }}
                                            >
                                                <Typography fontSize={13} fontWeight={600} color="white">Active</Typography>
                                            </Box>
                                            <Typography fontWeight={600} mt={1}>{a?.name || a?.subject?.name}</Typography>
                                        </Fragment>
                                    }
                                />
                            </Grid>
                        ))}
                    </Grid>
                }
            />
        </Fragment>
    )
}

export default SubjectOverview;